import React, { useState } from 'react';
import { Box, Paper, Grid, Stack, Button } from '@mui/material';
import { Edit as EditIcon, Save as SaveIcon, Cancel as CancelIcon } from '@mui/icons-material';
import { Event } from '@/types/events';
import { ViewMode } from './EventDetails/ViewMode';
import { EditMode } from './EventDetails/EditMode';

interface EventDetailsProps {
  event: Event;
  onUpdate: (updatedEvent: Event) => void;
}

export const EventDetails: React.FC<EventDetailsProps> = ({ event, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedEvent, setEditedEvent] = useState<Event>(event);

  const handleSave = () => {
    onUpdate(editedEvent);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditedEvent(event);
    setIsEditing(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
              {isEditing ? (
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={handleSave}
                  >
                    Save Changes
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<CancelIcon />}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Stack>
              ) : (
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  onClick={() => setIsEditing(true)}
                >
                  Edit Details
                </Button>
              )}
            </Box>

            {isEditing ? (
              <EditMode 
                event={editedEvent} 
                onChange={setEditedEvent} 
              />
            ) : (
              <ViewMode event={event} />
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};